

<edu-card class="settings-card">
  <h2 edu-card-title>Integrations</h2>

  <!-- Loading state -->
  <div class="loading-state" *ngIf="loading">
    <div class="spinner"></div>
    <p>Loading integrations...</p>
  </div>

  @if (!loading) {

    <!-- No accounts linked yet — show one default unlinked card -->
    @if (linkedZoomAccounts.length === 0) {
      <div class="integration-card">
        <div class="integration-content">
          <div class="integration-header">
            <div class="integration-info">
              <div class="integration-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M4 4h10a2 2 0 0 1 2 2v5.586l4.293-4.293A1 1 0 0 1 22 8v8a1 1 0 0 1-1.707.707L16 12.414V18a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
                </svg>
              </div>
              <div class="integration-details">
                <div class="name-status">
                  <h3 class="integration-name">Zoom</h3>
                </div>
                <p class="integration-description">
                  Connect your Zoom account to schedule and manage meetings
                </p>
              </div>
            </div>
            <div class="button-group">
              <button class="link-button" (click)="linkZoomAccount()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                </svg>
                Link Account
              </button>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Linked accounts list -->
    @for (account of linkedZoomAccounts; track account.id) {
      <div class="integration-card">
        <div class="integration-content">
          <div class="integration-header">
            <div class="integration-info">
              <div class="integration-icon linked">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M4 4h10a2 2 0 0 1 2 2v5.586l4.293-4.293A1 1 0 0 1 22 8v8a1 1 0 0 1-1.707.707L16 12.414V18a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
                </svg>
              </div>
              <div class="integration-details">
                <div class="name-status">
                  <h3 class="integration-name">Zoom</h3>
                  <span class="status-badge">Connected</span>
                </div>
                <div class="integration-description">
                  <p class="username">{{ account.zoomEmail }}</p>
                  <p class="meta">Linked {{ account.createdAt | date:'MMM d, y' }}</p>
                </div>
              </div>
            </div>
            <div class="button-group">
              <button class="link-button" (click)="linkZoomAccount()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                  stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
                </svg>
                Link Another
              </button>
            </div>
          </div>
        </div>
      </div>
    }

    <!-- Link another account button when accounts exist -->
    @if (linkedZoomAccounts.length > 0) {
      <action-button (click)="linkZoomAccount()" [text]="'Link Another Zoom Account'"></action-button>
    }

  }

</edu-card>